import { render, staticRenderFns } from "./VirtualAccountRecharge.vue?vue&type=template&id=0ad54873&scoped=true&"
import script from "./VirtualAccountRecharge.vue?vue&type=script&lang=js&"
export * from "./VirtualAccountRecharge.vue?vue&type=script&lang=js&"
import style0 from "./VirtualAccountRecharge.vue?vue&type=style&index=0&id=0ad54873&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad54873",
  null
  
)

export default component.exports